// extracted by mini-css-extract-plugin
module.exports = {"tip":"Detail_style_tip__3oNXY"};